import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const { t } = useLanguage();

  const contactDetails = [
    {
      icon: "Mail",
      label: t('contact.email'),
      value: "contact@gissellemendez.com",
      link: "mailto:contact@gissellemendez.com"
    },
    {
      icon: "Instagram",
      label: "Instagram",
      value: "@gissellemendez2",
      link: "https://instagram.com/gissellemendez2"
    },
    {
      icon: "MapPin",
      label: "Studio",
      value: "Barcelona, España",
      link: null
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center space-y-12"
        >
          {/* Header */}
          <div className="space-y-6">
            <h1 className="text-5xl md:text-7xl font-serif">{t('contact.title')}</h1>
            <div className="w-16 h-px bg-gallery-accent mx-auto"></div>
            <p className="text-gallery-muted font-light leading-relaxed max-w-2xl mx-auto text-lg">
              Para consultas sobre obras originales, comisiones personalizadas o colaboraciones, por favor contáctanos directamente a través de los siguientes canales.
            </p>
          </div>

          {/* Contact Methods */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-12">
            {contactDetails.map((detail, index) => (
              <motion.div 
                key={detail.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 + (index * 0.1) }}
                className="group p-8 bg-gallery-surface border border-gallery-border hover:border-gallery-accent transition-all duration-500"
              >
                <div className="flex flex-col items-center space-y-4">
                  <div className="p-3 bg-gallery-bg rounded-full text-gallery-accent group-hover:bg-gallery-accent group-hover:text-white transition-colors duration-500">
                    <SafeIcon name={detail.icon} className="w-6 h-6" />
                  </div>
                  <h3 className="text-xs uppercase tracking-[0.2em] text-gallery-muted">
                    {detail.label}
                  </h3>
                  {detail.link ? (
                    <a 
                      href={detail.link} 
                      target={detail.icon === 'Instagram' ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="text-lg font-serif hover:text-gallery-accent transition-colors"
                    >
                      {detail.value}
                    </a>
                  ) : (
                    <span className="text-lg font-serif">{detail.value}</span>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
            className="pt-20"
          >
            <p className="text-sm uppercase tracking-[0.3em] text-gallery-muted">
              Horario del Estudio: Cita Previa
            </p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;